import { Route } from "../Model/Route";
import { joinPath } from "./Helpers";
export class RoutesService {
    constructor(checkpointsFactory) {
        this.checkpointsFactory = checkpointsFactory;
        this.routesMap = new Map([
            ['a-la-orilla-del-mar', '/routes/route_1/route_1.json'],
            ['el-botanico', '/routes/route_2/route_2.json'],
            ['el-burgado', '/routes/route_3/route_3.json'],
            // ['la-vera'              , '/routes/route_4/route_4.json']
        ]);
    }
    async getAllRoutes() {
        const routesPaths = [...this.routesMap.values()];
        const routesStates = await Promise.all(routesPaths.map(statePath => this.loadState(statePath)));
        return routesStates.map(routeState => this.createRoute(routeState));
    }
    async getRoute(routeId) {
        if (!this.routesMap.has(routeId)) {
            return null;
        }
        const routeState = await this.loadState(this.routesMap.get(routeId));
        return this.createRoute(routeState);
    }
    async loadState(statePath) {
        const stateFolder = statePath.substring(0, statePath.lastIndexOf('/'));
        const response = await fetch.call(globalThis, statePath);
        if (!response.ok) {
            throw new Error(`Ha ocurrido un error al cargar la ruta: '${statePath}'`);
        }
        const routeState = await response.json();
        routeState.image = `${stateFolder}/${routeState.image}`;
        routeState.trivialIcon = `${stateFolder}/${routeState.trivialIcon}`;
        routeState.trivialIcons.block = `${stateFolder}/${routeState.trivialIcons.block}`;
        routeState.trivialIcons.completed = `${stateFolder}/${routeState.trivialIcons.completed}`;
        routeState.trivialIcons.accesible = `${stateFolder}/${routeState.trivialIcons.accesible}`;
        routeState.checkpoints.forEach(checkpointState => {
            checkpointState.icon = `${stateFolder}/${checkpointState.icon}`;
            checkpointState.image = `${stateFolder}/${checkpointState.image}`;
            checkpointState.activities = checkpointState.activities.map(activityPath => {
                return joinPath(stateFolder, activityPath);
            });
        });
        return routeState;
    }
    createRoute(routeState) {
        const checkpoints = routeState.checkpoints.map(checkpointState => {
            return this.checkpointsFactory.createCheckpoint(checkpointState);
        });
        return new Route(routeState.id, routeState.representation, routeState.name, routeState.surname, routeState.image, routeState.trivialIcons, routeState.color, routeState.meta, routeState.path, checkpoints);
    }
}
